import { GifAsset } from 'pixi.js/gif';
import { extensions } from 'pixi.js';

import { splitSvgLoader } from './assets/svg-loader';

export default function initPixiExtensions() {
  extensions.add(splitSvgLoader);
  extensions.add(GifAsset);
}
